const filters = {
  onlyActive: {
    dimension: 'Portfolios.status',
    operator: 'equals',
    values: ['Active']
  },
  resultsEnabled: {
    dimension: 'Results.enabled',
    operator: 'equals',
    values: ['1']
  },
  resultsNotRelevant: {
    dimension: 'Results.enabled',
    operator: 'notEquals',
    values: ['1']
  }
};

export const charts = {
  total_inv_amt: {
    resourceId: 'total_inv_amt',
    type: 'number',
    query: {
      measures: ['Investments.count', 'Investments.totalAmount'],
      dimensions: [],
      filters: [filters.onlyActive]
    },
    title: 'Total Investments Amount',
    description:
      'Cash, goods, volunteerism and services donated from {} investments',
    info:
      'A funder\'s claim on a program\'s impact is equal to the proportion of funding provided (e.g., funding 10% of a program earns ' +
        'a 10% claim on the program\'s outcome) and any resulting catalyzed (ripple) effects.'
  },
  total_reached: {
    resourceId: 'total_reached',
    type: 'number',
    query: {
      measures: ['Claims.totalClaim'],
      dimensions: [],
      filters: [
        filters.onlyActive,
        { dimension: 'Indicators.stageId', operator: 'equals', values: ['5'] }
      ]
    },
    title: 'Total Reached',
    description: 'Beneficiaries Reached (claim)',
    info:
      'A funder\'s claim on a program\'s impact is equal to the proportion of funding provided (e.g., funding 10% of a program earns ' +
        'a 10% claim on the program\'s outcome) and any resulting catalyzed (ripple) effects.'
  },
  total_si: {
    resourceId: 'total_si',
    type: 'number',
    query: {
      measures: ['Claims.totalClaim'],
      dimensions: [],
      filters: [
        filters.onlyActive,
        { dimension: 'Indicators.stageId', operator: 'equals', values: ['3'] }
      ]
    },
    title: 'Total Social Impact',
    info:
      'A funder\'s claim on a program\'s impact is equal to the proportion of funding provided (e.g., funding 10% of a program earns ' +
        'a 10% claim on the program\'s outcome) and any resulting catalyzed (ripple) effects.',
    description: 'Beneficiaries Succeed (claim)'
  },
  si_by_indicator: {
    resourceId: 'si_by_indicator',
    type: 'data-table',
    query: {
      measures: ['Claims.totalClaim'],
      dimensions: ['Indicators.name'],
      filters: [
        filters.onlyActive,
        { dimension: 'Indicators.stageId', operator: 'equals', values: ['3'] }
      ]
    },
    title: 'Social Impact (Detail)',
    info:
      'A funder\'s claim on a program\'s impact is equal to the proportion of funding provided (e.g., funding 10% of a program earns ' +
        'a 10% claim on the program\'s outcome) and any resulting catalyzed (ripple) effects.'
  },
  sroi: {
    resourceId: 'sroi',
    type: 'number',
    query: {
      measures: ['Claims.SROI'],
      dimensions: [],
      filters: [
        filters.onlyActive,
        { dimension: 'Indicators.stageId', operator: 'equals', values: ['3'] }
      ]
    },
    info:
      'Social return on investment (Social ROI) measures how much social value is created as a result of your philanthropic ' +
        'investment, enabling you to compare investments to determine which are most cost effective. Specifically, we calculate social ' +
        'ROI as: number of successes (e.g., beneficiaries that gain employment or food security) per $10,000 invested.',
    description:
      'How many beneficiaries achieved success for each $10,000 you invested (i.e., social return on investment)',
    title: 'SROI'
  },
  leverage: {
    resourceId: 'leverage',
    type: 'number',
    query: {
      measures: ['Claims.leveragePercentage'],
      dimensions: [],
      filters: [filters.onlyActive]
    },
    info:
      'In some cases, you can claim additional successes beyond those you are directly funding, if your investment results in ' +
        'additional "catalyzed" effects, including: Attracting additional funders required for program implementation (without which ' +
        'the program might not be implemented). Underwriting new service models that are replicated in the future.',
    description:
      '% of additional successes you can claim, beyond those you directly funded, due to catalyzed effects',
    title: 'Leverage'
  },
  data_quality: {
    resourceId: 'data_quality',
    type: 'circle-chart',
    query: {
      measures: ['Claims.count'],
      dimensions: ['Results.classification'],
      filters: [
        filters.onlyActive,
        { dimension: 'Indicators.stageId', operator: 'equals', values: ['3'] }
      ]
    },
    title: 'Data Quality',
    info:
      'Measurement types: Direct Measurement of program results, including testing, monitoring, or reporting by the beneficiaries or ' +
        'program implementers, using subjective or objective evaluation criteria; Estimate based on data from other, similar programs; ' +
        'indirect tracking of outcomes (e.g., government data); or this program\'s past results; Guess based on experience, anecdotal ' +
        'results, or logical assumptions'
  },
  compliance: {
    resourceId: 'compliance',
    type: 'chart',
    query: {
      measures: ['Reports.count'],
      dimensions: ['Reports.status'],
      filters: [filters.onlyActive]
    },
    info:
      'Draft: Grantee has not yet submitted a report for feedback; TI/Funder Feedback Provided: Grantee has submitted a report and ' +
        'received feedback, but has not responded with potential modifications; Awaiting TI/Funder Verification: Grantee has made ' +
        'adjustments and responsded to feedback; Published: Reporting process completed with current data, but future changes ' +
        'possible; Finalized: Reporting process completed and no further changes expected;',
    title: 'Compliance Chart'
  },
  feedback: {
    resourceId: 'feedback',
    type: 'number',
    query: {
      measures: ['Reports.count'],
      dimensions: [],
      filters: [
        filters.onlyActive,
        {
          dimension: 'Reports.status',
          operator: 'equals',
          values: ['Awaiting Funder Feedback', 'Awaiting Funder Verification']
        }
      ]
    },
    info: 'Number of reports awaiting funder feedback or funder verification',
    title: 'Awaiting Feedback',
    description:
      'Number of reports awaiting funder feedback or funder verification'
  },
  ratings: {
    resourceId: 'ratings',
    type: 'data-table',
    query: {
      measures: ['FunderRatings.count'],
      dimensions: ['FunderRatings.value', 'FunderRatings.funderRatingCategory'],
      filters: [filters.onlyActive]
    },
    info:
      'Review how all the reports within your investments have been rated by unique categories.',
    title: 'Report Ratings'
  }
};

export default charts;
